<template>
  <div class="lg:mb-10 lg:flex lg:items-start">
    <div class="lg:pl-6 lg:grow lg:gap-2 lg:grid lg:cols-2 <lg:hidden">
      <div
        v-for="i in 6"
        :key="i"
        class="skeleton"
        :class="{
          'col-span-2': [3, 4].includes(i),
        }"
        :style="{ 'aspect-ratio': presets.src.width / presets.src.height }"
      />
    </div>
    <div
      class="skeleton lg:hidden"
      :style="{ 'aspect-ratio': presets.src.width / presets.src.height }"
    />
    <div
      v-style="{ w: { lg: '30rem' }, top: { lg: '9rem' } }"
      class="px-4 pb-4 f-col gap-y-2 lg:px-6 lg:pt-4 lg:shrink-0 lg:sticky"
    >
      <div class="space-y-2 <lg:hidden">
        <div class="mt-2 h-7 w-full skeleton" />
        <div class="h-4 w-75 skeleton" />
        <div class="h-4 w-30 skeleton" />
        <div class="h-4 w-64 skeleton" />
      </div>
      <div class="mb-4 mt-4 lg:mb-6">
        <div class="flex wrap -ml-2">
          <div
            v-for="i in 5"
            :key="i"
            class="m-2 skeleton"
            :style="{ width: '1.5rem', height: '1.5rem' }"
          />
        </div>
        <div class="mt-2 flex w-full between">
          <div class="h-4 w-24 skeleton" />
          <div class="h-4 w-24 skeleton" />
        </div>
      </div>
      <div class="space-y-2 lg:hidden">
        <div class="mt-2 h-7 w-full skeleton" />
        <div class="h-4 w-75 skeleton" />
        <div class="h-4 w-30 skeleton" />
        <div class="h-4 w-64 skeleton" />
      </div>
      <div class="flex gap-2 w-full">
        <div v-style:min-w="`7.5rem`" class="shrink h-13 skeleton" />
        <div class="grow h-13 skeleton" />
      </div>
      <div class="mt-2 flex w-full between">
        <div class="h-4 w-30 skeleton" />
        <div class="h-4 w-64 skeleton" />
      </div>
      <hr class="c-grey-80 mt-4">
      <div class="mt-2 flex gap-2 w-full">
        <div class="h-6 w-24 skeleton" />
        <div class="h-6 w-24 skeleton" />
        <div class="h-6 w-24 skeleton" />
        <div class="h-6 w-24 skeleton" />
        <div class="h-6 w-24 skeleton" />
      </div>
      <div class="mt-2 flex gap-2 w-full between">
        <div class="h-24 w-30 skeleton" />
        <div class="h-24 w-30 skeleton" />
        <div class="h-24 w-30 skeleton" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const { presets } = useAppConfig().pages.pdp.gallery
</script>
